import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { canAccessPath } from "./components/access-side";

import Loading from "./page/Loading";
import Login from "./page/Login";
import Template from "./page/Template";
import Console from "./page/admin/Console";
import Dashboard from "./page/admin/dashboard";
import Expenses from "./page/admin/Expenses";
import UploadData from "./page/admin/upload-data";
import OutstandingPaymentsAdmin from "./page/admin/outstanding-payments";
import PaymentHistory from "./page/admin/payment-history";
import Customer from "./page/admin/Customer";
import User from "./page/admin/User";
import ExpenseTypes from "./page/admin/expense-types";
import BankAccounts from "./page/admin/bank-accounts";
import Role from "./page/admin/Role";
import Banners from "./page/admin/Banners";
import Announcements from "./page/admin/announcements";
import News from "./page/admin/news";
import SettingCashFlowReport from "./page/admin/setting-cash-flow-report";
import CashFlowReport from "./page/admin/cash-flow-report";
import PettyCashReport from "./page/admin/petty-cash-report";
import CategorizedReport from "./page/admin/categorized-report";
import Logs from "./page/admin/Logs";
import SaleInquiries from "./page/admin/sale-inquiries";
import SalePageContents from "./page/admin/sale-page-contents";
import SaleProjectSettings from "./page/admin/sale-project-settings";
import ProjectRoomAll from "./page/admin/project-room-all";
import ProjectRoomEdit from "./page/admin/project-room-edit";
import SaleDashboard from "./page/admin/sale-dashboard";
import SaleListingLogs from "./page/admin/sale-listing-logs";


import Notfound from "./page/Notfound";

import ReceiptDocument from "./document/Receipt";
import ReceiptOtherDocument from "./document/ReceiptOther";
import InvoiceByRoomDocument from "./document/InvoiceByRoom";
import InvoiceOtherDocument from "./document/InvoiceOther";
import LetterDocument from "./document/Letter";

// แยกสิทธิ์ 2 ระบบ (เฟส 2 / งานขาย) — ไม่มีสิทธิ์ฝั่งนั้นเด้งกลับ /console ไม่ขึ้นข้อความ
// อ่านโปรไฟล์สดจาก localStorage ทุกครั้ง (Navbar/Console อัปเดตสิทธิ์ล่าสุดลงไปแล้ว)
const readProfile = () => {
  try {
    return JSON.parse(localStorage.getItem("cds-profile"));
  } catch (e) {
    return null;
  }
};
const Guard = ({ children }) => {
  const { pathname } = useLocation();
  if (!localStorage.getItem("cds-acc-tk")) return children;
  return canAccessPath(pathname, readProfile()) ? children : <Navigate to="/console" replace />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Loading />} />
    <Route path="/login" element={<Login />} />
    <Route path="/template" element={<Template />} />

    <Route path="/console" element={<Console />} />
    <Route path="/dashboard" element={<Guard><Dashboard /></Guard>} />
    <Route path="/expenses" element={<Guard><Expenses /></Guard>} />
    <Route path="/upload-data" element={<Guard><UploadData /></Guard>} />
    <Route path="/outstanding-payments" element={<Guard><OutstandingPaymentsAdmin /></Guard>} />
    <Route path="/payment-history" element={<Guard><PaymentHistory /></Guard>} />
    <Route path="/customer" element={<Guard><Customer /></Guard>} />
    <Route path="/user" element={<Guard><User /></Guard>} />
    <Route path="/expense-types" element={<Guard><ExpenseTypes /></Guard>} />
    <Route path="/bank-accounts" element={<Guard><BankAccounts /></Guard>} />
    <Route path="/role" element={<Guard><Role /></Guard>} />
    <Route path="/banners" element={<Guard><Banners /></Guard>} />
    <Route path="/announcements" element={<Guard><Announcements /></Guard>} />
    <Route path="/news" element={<Guard><News /></Guard>} />
    <Route path="/setting-cash-flow-report" element={<Guard><SettingCashFlowReport /></Guard>} />
    <Route path="/cash-flow-report" element={<Guard><CashFlowReport /></Guard>} />
    <Route path="/petty-cash-report" element={<Guard><PettyCashReport /></Guard>} />
    <Route path="/categorized-report" element={<Guard><CategorizedReport /></Guard>} />
    <Route path="/logs" element={<Guard><Logs /></Guard>} />
    <Route path="/sale-inquiries" element={<Guard><SaleInquiries /></Guard>} />
    <Route path="/sale-page-contents" element={<Guard><SalePageContents /></Guard>} />
    <Route path="/sale-project-settings" element={<Guard><SaleProjectSettings /></Guard>} />
    <Route path="/project-room-all" element={<Guard><ProjectRoomAll /></Guard>} />
    {/* แก้ไข/ลงประกาศทรัพย์ทีละห้อง — /project-room-edit?customer_id=... */}
    <Route path="/project-room-edit" element={<Guard><ProjectRoomEdit /></Guard>} />
    <Route path="/sale-dashboard" element={<Guard><SaleDashboard /></Guard>} />
    {/* ประวัติ flow ขาย — เจาะห้องเดียวได้ด้วย ?listing_uid=... */}
    <Route path="/sale-listing-logs" element={<Guard><SaleListingLogs /></Guard>} />

    {/* ★ หน้าที่เลิกใช้แล้ว — เก็บ URL เดิมไว้ redirect ไม่ให้ bookmark/ลิงก์เก่าตกหน้า 404
        /project-room-sales : หน้าดูอย่างเดียวที่ไม่มีเมนูชี้มาแล้ว งานทั้งหมดอยู่ที่ /project-room-all
        /admin-contacts     : ข้อมูลติดต่อ Admin ย้ายไปอยู่ที่ "การตั้งค่าการขาย (โครงการ)" */}
    <Route path="/project-room-sales" element={<Navigate to="/project-room-all" replace />} />
    <Route path="/admin-contacts" element={<Navigate to="/sale-project-settings" replace />} />


    <Route path="/doc/receipt" element={<ReceiptDocument />} />
    <Route path="/doc/receipt-other" element={<ReceiptOtherDocument />} />
    <Route path="/doc/invoice-by-room" element={<InvoiceByRoomDocument />} />
    <Route path="/doc/invoice-other" element={<InvoiceOtherDocument />} />
    <Route path="/doc/letter" element={<LetterDocument />} />

    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
